<template>
  <div class="wrapper-content">
    <div class="wrapper-left">
      <div class="store-house-left-operation">
        <div class="two-font-wrapper" @click="showAddModal"><div class="icon-font">&#xe605;</div>添加</div>
        <div class="two-font-wrapper" @click="showDeleteModal"><div class="icon-font">&#xe646;</div>删除</div>
      </div>
      <div class="store-house-left-content">
        <el-tree
          :load="loadNode"
          lazy
          node-key="treeId"
          ref="tree"
          :defaultExpandedKeys="defaultExpandedKeys"
          highlight-current
          :check-strictly="true"
          :accordion="true"
          :auto-expand-parent="true"
          :expand-on-click-node="false"
          @current-change="checkChange"
          :props="defaultProps">
        </el-tree>
      </div>
    </div>
    <div class="wrapper-right">
      <transition name="enter-fade">
        <div class="wrapper-right-content" v-if="treeId !== '000'">
          <div class="look-nav">
            <div class="handle-wrapper" style="opacity: 0"><div class="icon-font">&#xec11;</div>编辑</div>
            <div class="look-nav-center">{{title}}</div>
            <div class="handle-wrapper" @click="handleEdit"><div class="icon-font">&#xec11;</div>编辑</div>
          </div>
          <div class="loading-data" v-if="loading">
            <i class="el-icon-loading"></i>
            <div>加载中，请稍后···</div>
          </div>
          <div v-if="!loading">
            <transition name="enter-fade">
              <div class="store-house-right-content" v-if="warehouseNodeType === '01'">
                <div class="house-list" style="width: 100%">
                  <div class="input-contain">
                    <div class="input-title" style="padding-left: 1.78vw">仓库名称：</div>
                    <div class="input-wrapper">
                      <input v-model="warehouse.name" placeholder=""/>
                    </div>
                  </div>
                  <div class="input-contain">
                    <div class="input-title" style="padding-left: 0.89vw">建造时间：</div>
                    <div class="input-wrapper">
                      <el-date-picker
                        @change="changeBuildTime"
                        v-model="warehouse.buildTime"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                      </el-date-picker>
                    </div>
                  </div>
                  <div class="input-contain">
                    <div class="input-title" style="padding-left: 2.67vw">库龄：</div>
                    <div class="input-suffix-wrapper" style="margin-right: 0">
                      <input v-model="warehouse.age" disabled="true" placeholder=""/>
                      <div class="input-suffix">(天)</div>
                    </div>
                  </div>
                </div>
                <div class="house-list" style="width: 100%">
                  <div class="input-contain">
                    <div class="input-title" style="padding-left: 1.78vw">仓库代码：</div>
                    <div class="input-wrapper">
                      <el-input v-model="warehouse.code" placeholder=""/>
                    </div>
                  </div>
                  <div class="input-contain">
                    <div class="input-title">可堆货容积：</div>
                    <div class="input-wrapper">
                      <input v-model="warehouse.useVolume" placeholder=""/>
                    </div>
                  </div>
                  <div class="input-contain">
                    <div class="input-title" style="padding-left: 0.89vw">容积单位：</div>
                    <div class="input-wrapper">
                      <input v-model="warehouse.useVolumeUnit" placeholder=""/>
                    </div>
                  </div>
                </div>
                <div class="house-list" style="width: 100%;position: relative;z-index: 99">
                  <div class="input-contain">
                    <div class="input-title" style="padding-left: 0.89vw">可堆货面积：</div>
                    <div class="input-wrapper">
                      <input v-model="warehouse.useArea" placeholder=""/>
                    </div>
                  </div>
                  <div class="input-contain">
                    <div class="input-title" style="padding-left: 0.89vw">面积单位：</div>
                    <div class="input-wrapper">
                      <input v-model="warehouse.useAreaUnit" placeholder=""/>
                    </div>
                  </div>
                  <div class="input-contain">
                    <div class="input-title">初始化仓库：</div>
                    <DropDown :content="warehouse.isAutomation ? '是' : '否'" :items="RandW" v-on:sendInfo = "warehouseIsAutomation"></DropDown>
                  </div>
                </div>
                <div class="house-list" style="width: 100%;position: relative;z-index: 98">
                  <div class="input-contain">
                    <div class="input-title">是否统计数据：</div>
                    <DropDown :content="warehouse.isStatistics ? '是' : '否'" :items="RandW" v-on:sendInfo = "warehouseIsStatistics"></DropDown>
                  </div>
                  <div class="input-contain">
                    <div class="input-title" style="padding-left: 0.89vw">是否启用：</div>
                    <DropDown :content="warehouse.isUsing ? '是' : '否'" :items="RandW" v-on:sendInfo = "warehouseIsUsing"></DropDown>
                  </div>
                  <div class="input-contain" style="opacity: 0">
                    <div class="input-title">可堆货面积：</div>
                    <div class="input-wrapper">
                      <input placeholder=""/>
                    </div>
                  </div>
                </div>
                <div class="text-area-wrapper">
                  <div class="text-area-title" style="padding-left: 3.56vw">备注：</div>
                  <textarea v-model="warehouse.remark" class="text-area-input"></textarea>
                </div>
              </div>
              <div class="store-house-right-content" v-if="warehouseNodeType === '02'">
                <div class="house-list" style="width: 100%">
                  <div class="input-contain">
                    <div class="input-title" style="padding-left: 0.89vw;">楼号名称：</div>
                    <div class="input-wrapper">
                      <input v-model="building.buildingName" placeholder=""/>
                    </div>
                  </div>
                  <div class="input-contain">
                    <div class="input-title">楼号代码：</div>
                    <div class="input-wrapper">
                      <input onkeyup="value=value.replace(/[\u4e00-\u9fa5]/ig,'')" v-model="building.buildingNo" placeholder=""/>
                    </div>
                  </div>
                  <div class="input-contain">
                    <div class="input-title">楼宇朝向：</div>
                    <div class="input-wrapper">
                      <input v-model="building.buildingOrientation" placeholder=""/>
                    </div>
                  </div>
                </div>
                <div class="house-list" style="width: 100%">
                  <div class="input-contain">
                    <div class="input-title">可堆货容积：</div>
                    <div class="input-wrapper">
                      <input v-model="building.useVolume" placeholder=""/>
                    </div>
                  </div>
                  <div class="input-contain">
                    <div class="input-title" style="padding-left: 0.83vw">容积单位：</div>
                    <div class="input-wrapper">
                      <input v-model="building.useVolumeUnit" placeholder=""/>
                    </div>
                  </div>
                  <div class="input-contain">
                    <div class="input-title">可堆货面积：</div>
                    <div class="input-wrapper">
                      <input v-model="building.useArea" placeholder=""/>
                    </div>
                  </div>
                </div>
                <div class="house-list" style="width: 100%">
                  <div class="input-contain">
                    <div class="input-title" style="padding-left: 0.89vw;">面积单位：</div>
                    <div class="input-wrapper">
                      <input v-model="building.useAreaUnit" placeholder=""/>
                    </div>
                  </div>
                </div>
                <div class="text-area-wrapper">
                  <div class="text-area-title" style="padding-left: 2.67vw">备注：</div>
                  <textarea v-model="building.remark" class="text-area-input"></textarea>
                </div>
              </div>
              <div class="store-house-right-content" v-if="warehouseNodeType === '03'">
                <div class="house-list" style="width: 100%">
                  <div class="input-contain">
                    <div class="input-title">层号名称：</div>
                    <div class="input-wrapper">
                      <input v-model="floor.floorName" placeholder=""/>
                    </div>
                  </div>
                  <div class="input-contain">
                    <div class="input-title">层号代码：</div>
                    <div class="input-wrapper">
                      <input onkeyup="value=value.replace(/[\u4e00-\u9fa5]/ig,'')" v-model="floor.floorNo" placeholder=""/>
                    </div>
                  </div>
                  <div class="input-contain">
                    <div class="input-title">是否分区：</div>
                    <DropDown :content="floor.isPartition ? '是' : '否'" :items="RandW" v-on:sendInfo = "areaIsPartition"></DropDown>
                  </div>
                </div>
                <div class="text-area-wrapper">
                  <div class="text-area-title" style="padding-left: 1.79vw">备注：</div>
                  <textarea v-model="floor.remark" class="text-area-input"></textarea>
                </div>
              </div>
              <div class="store-house-right-content" v-if="warehouseNodeType === '04'">
                <div class="store-house-right-content-top">
                  <div class="house-list" style="width: 100%;justify-content: flex-start">
                    <div class="input-contain" style="margin-right: 3vw">
                      <div class="input-title">区号名称：</div>
                      <div class="input-wrapper">
                        <input v-model="area.areaName" placeholder=""/>
                      </div>
                    </div>
                    <div class="input-contain">
                      <div class="input-title">区号代码：</div>
                      <div class="input-wrapper">
                        <input onkeyup="value=value.replace(/[\u4e00-\u9fa5]/ig,'')" v-model="area.areaNo" placeholder=""/>
                      </div>
                    </div>
                  </div>
                  <div class="text-area-wrapper">
                    <div class="text-area-title" style="padding-left: 1.79vw">备注：</div>
                    <textarea v-model="area.remark" class="text-area-input"></textarea>
                  </div>
                </div>
                <div class="store-house-right-content-bottom">
                  <div class="s-h-r-c-b-operation">
                    <div class="two-font-wrapper" style="margin-right: 1vw" @click="showAddCribModal(1)"><div class="icon-font">&#xe605;</div>添加</div>
                  </div>
                  <div class="detail">
                    <div class="detail-box">
                      <div class="detail-nav">
                        <div class="detail-item" style="width: 10%">序号</div>
                        <div class="detail-item" style="width: 20%">垛位编号</div>
                        <div class="detail-item" style="width: 20%">中文全称</div>
                        <div class="detail-item" style="width: 30%">备注</div>
                        <div class="detail-item" style="width: 20%">操作</div>
                      </div>
                      <div class="detail-content" v-if="!loading_">
                        <div class="detail-list-wrapper" v-for="(data,index) in tableData" :key="index">
                          <div class="detail-item" style="width: 10%">{{index+ 1}}</div>
                          <div class="detail-item" style="width: 20%">{{data.stackNo}}</div>
                          <div class="detail-item" style="width: 20%">{{data.nameCn}}</div>
                          <div class="detail-item" style="width: 30%">{{data.remark}}</div>
                          <div class="detail-item" style="width: 20%">
                            <div class="detail-btn item-look" style="margin-right: 0.5vw" @click="showAddCribModal(2, data)">修改</div>
                            <div class="detail-btn item-delete" @click="deleteSingle(data.id)">删除</div>
                          </div>
                        </div>
                        <div class="none-data" v-if="!loading_ && tableData.length<1">暂无数据</div>
                      </div>
                      <div class="page-wrapper" v-if="!loading_ && total > rows">
                        <div class="page-wrapper-left">共{{total}}条数据，每页显示{{rows}}条，当前第{{page}}页</div>
                        <div class="page-wrapper-right">
                          <div class="page-btn" @click="firstPage">首页</div>
                          <div class="page-btn" @click="previousPage">上一页</div>
                          <div class="page-btn" @click="nextPage">下一页</div>
                          <div class="page-btn" @click="lastPage">尾页</div>
                        </div>
                      </div>
                    </div>
                    <transition name="fade">
                      <div class="alert-box" v-if="show">
                        <div class="alert-content">
                          <div class="alert-content-title">删除提醒</div>
                          <div class="alert-content-msg">是否确认删除选中数据?</div>
                          <div class="alert-content-btn">
                            <div class="btn-cancel button" @click="cancelDelete">取消</div>
                            <div class="btn-confirm button" @click="confirmDelete">确认</div>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>
                <transition name="fade">
                  <div class="alert-box" v-if="showAddCrib">
                    <div class="alert-content" style="width: auto;padding: 1vw 2vw">
                      <div class="alert-content-title">{{cribType === 1 ? '添加垛位' : '修改垛位'}}</div>
                      <div class="alert-content-msg" style="width: 100%;flex-direction: column">
                        <div class="house-list">
                          <div class="input-contain" style="margin-right: 2vw">
                            <div class="input-title">垛位编号：</div>
                            <div class="input-wrapper">
                              <input onkeyup="value=value.replace(/[\u4e00-\u9fa5]/ig,'')" v-model="stack.stackNo" placeholder=""/>
                            </div>
                          </div>
                          <div class="input-contain">
                            <div class="input-title">中文全称：</div>
                            <div class="input-wrapper">
                              <input v-model="stack.nameCn" placeholder=""/>
                            </div>
                          </div>
                        </div>
                        <div class="text-area-wrapper">
                          <div class="text-area-title" style="padding-left: 1.78vw">备注：</div>
                          <textarea v-model="stack.remark" class="text-area-input"></textarea>
                        </div>
                      </div>
                      <div class="alert-content-btn">
                        <div class="btn-cancel button" @click="cancelAddCrib">取消</div>
                        <div class="btn-confirm button" @click="confirmAddCrib">确认</div>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </transition>
          </div>
        </div>
        <div class="top-content" v-if="treeId === '000'">
          <i class="icon-font">&#xe6be;</i>
          <span>请选择仓库</span>
        </div>
      </transition>
    </div>
    <transition name="fade">
      <div class="alert-box" v-if="showAdd">
        <div class="alert-content" style="width: 65vw;padding: 1vw 2vw">
          <div class="alert-content-title">{{warehouseNodeType_ === '01' ? '添加仓库' : warehouseNodeType_ === '02' ? '添加楼号' : warehouseNodeType_ === '03' ? '添加楼层' : '添加库区'}}</div>
          <div class="alert-content-msg" style="width: 100%;flex-direction: column" v-if="warehouseNodeType_ === '01'">
            <div class="house-list" style="width: 100%">
              <div class="input-contain">
                <div class="input-title" style="padding-left: 1.78vw">仓库名称：</div>
                <div class="input-wrapper">
                  <input v-model="warehouse_.name" placeholder=""/>
                </div>
              </div>
              <div class="input-contain">
                <div class="input-title" style="padding-left: 0.89vw">建造时间：</div>
                <div class="input-wrapper">
                  <el-date-picker
                    @change="changeBuildTime_"
                    v-model="warehouse_.buildTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                  </el-date-picker>
                </div>
              </div>
              <div class="input-contain">
                <div class="input-title" style="padding-left: 2.67vw">库龄：</div>
                <div class="input-suffix-wrapper" style="margin-right: 0">
                  <input v-model="warehouse_.age" disabled="true" placeholder=""/>
                  <div class="input-suffix">(天)</div>
                </div>
              </div>
            </div>
            <div class="house-list" style="width: 100%">
              <div class="input-contain">
                <div class="input-title" style="padding-left: 1.78vw">仓库代码：</div>
                <div class="input-wrapper">
                  <input @input="changeInput" v-model="warehouse_.code" placeholder=""/>
                </div>
              </div>
              <div class="input-contain">
                <div class="input-title">可堆货容积：</div>
                <div class="input-wrapper">
                  <input v-model="warehouse_.useVolume" placeholder=""/>
                </div>
              </div>
              <div class="input-contain">
                <div class="input-title" style="padding-left: 0.89vw">容积单位：</div>
                <div class="input-wrapper">
                  <input v-model="warehouse_.useVolumeUnit" placeholder=""/>
                </div>
              </div>
            </div>
            <div class="house-list" style="width: 100%;position: relative;z-index: 99">
              <div class="input-contain">
                <div class="input-title" style="padding-left: 0.89vw">可堆货面积：</div>
                <div class="input-wrapper">
                  <input v-model="warehouse_.useArea" placeholder=""/>
                </div>
              </div>
              <div class="input-contain">
                <div class="input-title" style="padding-left: 0.89vw">面积单位：</div>
                <div class="input-wrapper">
                  <input v-model="warehouse_.useAreaUnit" placeholder=""/>
                </div>
              </div>
              <div class="input-contain">
                <div class="input-title">初始化仓库：</div>
                <DropDown :content="warehouse_.isAutomation ? '是' : '否'" :items="RandW" v-on:sendInfo = "warehouseIsAutomation_"></DropDown>
              </div>
            </div>
            <div class="house-list" style="width: 100%;position: relative;z-index: 98">
              <div class="input-contain">
                <div class="input-title">是否统计数据：</div>
                <DropDown :content="warehouse_.isStatistics ? '是' : '否'" :items="RandW" v-on:sendInfo = "warehouseIsStatistics_"></DropDown>
              </div>
              <div class="input-contain">
                <div class="input-title" style="padding-left: 0.89vw">是否启用：</div>
                <DropDown :content="warehouse_.isUsing ? '是' : '否'" :items="RandW" v-on:sendInfo = "warehouseIsUsing_"></DropDown>
              </div>
              <div class="input-contain">
                <div class="input-title" style="padding-left: 0.89vw">上级仓库：</div>
                <LoadingTree :content="title_" :editCheckId="treeId" v-on:sendInfo = "showDropInfo"></LoadingTree>
              </div>
            </div>
            <div class="text-area-wrapper">
              <div class="text-area-title" style="padding-left: 3.56vw">备注：</div>
              <textarea v-model="warehouse_.remark" class="text-area-input"></textarea>
            </div>
          </div>
          <div class="alert-content-msg" style="width: 100%;flex-direction: column" v-if="warehouseNodeType_ === '02'">
            <div class="house-list" style="width: 100%">
              <div class="input-contain">
                <div class="input-title" style="padding-left: 0.83vw">楼号名称：</div>
                <div class="input-wrapper">
                  <input v-model="building_.buildingName" placeholder=""/>
                </div>
              </div>
              <div class="input-contain">
                <div class="input-title">楼号代码：</div>
                <div class="input-wrapper">
                  <input onkeyup="value=value.replace(/[\u4e00-\u9fa5]/ig,'')" v-model="building_.buildingNo" placeholder=""/>
                </div>
              </div>
              <div class="input-contain">
                <div class="input-title">楼宇朝向：</div>
                <div class="input-wrapper">
                  <input v-model="building_.buildingOrientation" placeholder=""/>
                </div>
              </div>
            </div>
            <div class="house-list" style="width: 100%">
              <div class="input-contain">
                <div class="input-title">可堆货容积：</div>
                <div class="input-wrapper">
                  <input v-model="building_.useVolume" placeholder=""/>
                </div>
              </div>
              <div class="input-contain">
                <div class="input-title" style="padding-left: 0.83vw">容积单位：</div>
                <div class="input-wrapper">
                  <input v-model="building_.useVolumeUnit" placeholder=""/>
                </div>
              </div>
              <div class="input-contain">
                <div class="input-title">可堆货面积：</div>
                <div class="input-wrapper">
                  <input v-model="building_.useArea" placeholder=""/>
                </div>
              </div>
            </div>
            <div class="house-list" style="width: 100%;position: relative;z-index: 98">
              <div class="input-contain">
                <div class="input-title" style="padding-left: 0.83vw">面积单位：</div>
                <div class="input-wrapper">
                  <input v-model="building_.useAreaUnit" placeholder=""/>
                </div>
              </div>
              <div class="input-contain">
                <div class="input-title">上级仓库：</div>
                <LoadingTree :content="title_" :editCheckId="treeId" v-on:sendInfo = "showDropInfo"></LoadingTree>
              </div>
              <div class="input-contain" style="opacity: 0">
                <div class="input-title">面积单位：</div>
                <div class="input-wrapper">
                  <input placeholder=""/>
                </div>
              </div>
            </div>
            <div class="text-area-wrapper">
              <div class="text-area-title" style="padding-left: 2.67vw">备注：</div>
              <textarea v-model="building_.remark" class="text-area-input"></textarea>
            </div>
          </div>
          <div class="alert-content-msg" style="width: 100%;flex-direction: column" v-if="warehouseNodeType_ === '03'">
            <div class="house-list" style="width: 100%">
              <div class="input-contain">
                <div class="input-title">层号名称：</div>
                <div class="input-wrapper">
                  <input v-model="floor_.floorName" placeholder=""/>
                </div>
              </div>
              <div class="input-contain">
                <div class="input-title">层号代码：</div>
                <div class="input-wrapper">
                  <input onkeyup="value=value.replace(/[\u4e00-\u9fa5]/ig,'')" v-model="floor_.floorNo" placeholder=""/>
                </div>
              </div>
              <div class="input-contain">
                <div class="input-title">是否分区：</div>
                <DropDown :content="floor_.isPartition ? '是' : '否'" :items="RandW" v-on:sendInfo = "areaIsPartition_"></DropDown>
              </div>
            </div>
            <div class="house-list" style="width: 100%">
              <div class="input-contain">
                <div class="input-title">上级仓库：</div>
                <LoadingTree :content="title_" :editCheckId="treeId" v-on:sendInfo = "showDropInfo"></LoadingTree>
              </div>
            </div>
            <div class="text-area-wrapper">
              <div class="text-area-title" style="padding-left: 1.73vw">备注：</div>
              <textarea v-model="floor_.remark" class="text-area-input"></textarea>
            </div>
          </div>
          <div class="alert-content-msg" style="width: 100%;flex-direction: column" v-if="warehouseNodeType_ === '04'">
            <div class="house-list" style="width: 100%;">
              <div class="input-contain" style="margin-right: 3vw">
                <div class="input-title">区号名称：</div>
                <div class="input-wrapper">
                  <input v-model="area_.areaName" placeholder=""/>
                </div>
              </div>
              <div class="input-contain">
                <div class="input-title">区号代码：</div>
                <div class="input-wrapper">
                  <input onkeyup="value=value.replace(/[\u4e00-\u9fa5]/ig,'')" v-model="area_.areaNo" placeholder=""/>
                </div>
              </div>
              <div class="input-contain">
                <div class="input-title">上级仓库：</div>
                <LoadingTree :content="title_" :editCheckId="treeId" v-on:sendInfo = "showDropInfo"></LoadingTree>
              </div>
            </div>
            <div class="text-area-wrapper">
              <div class="text-area-title" style="padding-left: 1.73vw">备注：</div>
              <textarea v-model="area_.remark" class="text-area-input"></textarea>
            </div>
          </div>
          <div class="alert-content-btn">
            <div class="btn-cancel button" @click="cancelAdd">取消</div>
            <div class="btn-confirm button" @click="confirmAdd">确认</div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="alert-box" v-if="showDelete">
        <div class="alert-content">
          <div class="alert-content-title">删除提醒</div>
          <div class="alert-content-msg">是否确认删除选中数据?</div>
          <div class="alert-content-btn">
            <div class="btn-cancel button" @click="cancelDeleteN">取消</div>
            <div class="btn-confirm button" @click="confirmDeleteN">确认</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import DropDown from '../../../components/DropDownSingle.vue'
import LoadingTree from '../../../components/LoadingTree.vue'
import {warehouseNode, warehouseInfo, delWarehouse, addWarehouse, addBuilding, addFloor, addWarearea, updateWarehouse, updateBuilding, updateFloor, updateWarearea, stackPageList, addStack, updateStack} from '../../../api/basic'
import {daysDistance, NonChineseInput, noEmpty} from '../../../tools/methods'
export default {
  name: 'Storehouse',
  components: { DropDown, LoadingTree },
  data () {
    return {
      value: '',
      warehouseNodeId: '',
      warehouseNodeId_: '',
      warehouseNodeType: '', // 仓库类型：'01'仓库、'02'楼、'03'层、'04'区
      warehouseNodeType_: '', // 仓库类型：'01'仓库、'02'楼、'03'层、'04'区
      warehouse: {
        name: '',
        age: '',
        buildTime: '',
        code: '',
        useVolume: '',
        useVolumeUnit: '',
        useArea: '',
        useAreaUnit: '',
        isAutomation: '',
        isStatistics: '',
        isUsing: '',
        remark: '',
        id: ''
      },
      warehouse_: {
        name: '',
        age: '',
        buildTime: '',
        code: '',
        useVolume: '',
        useVolumeUnit: '',
        useArea: '',
        useAreaUnit: '',
        isAutomation: '',
        isStatistics: '',
        isUsing: '',
        remark: '',
        id: ''
      },
      building: {
        buildingName: '',
        buildingNo: '',
        useVolume: '',
        useVolumeUnit: '',
        useArea: '',
        useAreaUnit: '',
        buildingOrientation: '',
        remark: '',
        warehouseId: '',
        id: ''
      },
      building_: {
        buildingName: '',
        buildingNo: '',
        useVolume: '',
        useVolumeUnit: '',
        useArea: '',
        useAreaUnit: '',
        buildingOrientation: '',
        remark: '',
        warehouseId: '',
        id: ''
      },
      floor: {
        floorName: '',
        floorNo: '',
        isPartition: '',
        remark: '',
        buildingId: '',
        id: ''
      },
      floor_: {
        floorName: '',
        floorNo: '',
        isPartition: '',
        remark: '',
        buildingId: '',
        id: ''
      },
      area: {
        areaName: '',
        areaNo: '',
        remark: '',
        floorId: '',
        id: ''
      },
      area_: {
        areaName: '',
        areaNo: '',
        remark: '',
        floorId: '',
        id: ''
      },
      stack: {
        nameCn: '',
        remark: '',
        stackNo: '',
        areaId: '',
        id: ''
      },
      loading: false,
      loading_: false,
      title: '',
      title_: '',
      show: false,
      id: '',
      showAddCrib: false,
      showAdd: false,
      showDelete: false,
      treeId: '011',
      treeId_: '011',
      defaultExpandedKeys: ['000'],
      showArea: false,
      defaultProps: {
        children: 'children',
        label: 'name',
        isLeaf: 'leaf'
      },
      RandW: [
        {name: '是', value: true},
        {name: '否', value: false}
      ],
      page: 1,
      rows: 6,
      total: '',
      tableData: [],
      cribType: ''
    }
  },
  methods: {
    changeInput: function (e) {
      return NonChineseInput(e.target.value)
    },
    changeBuildTime: function (v) {
      console.log(v)
      this.warehouse.age = daysDistance(v)
    },
    changeBuildTime_: function (v) {
      console.log(v)
      this.warehouse_.age = daysDistance(v)
    },
    loadNode (node, resolve) {
      console.log(node)
      if (node.level === 0) {
        this.requestTree(resolve)
      }
      // 其余节点处理
      if (node.level >= 1) {
        // resolve传到你自己的异步中去
        this.getIndex(node, resolve, node.level)
      }
    },
    // 异步加载叶子节点数据函数
    getIndex (node, resolve, level) {
      console.log(node.data.childSiteType)
      if (node.data.childSiteType === null || node.data.childSiteType === '05') {
        resolve([])
      } else {
        let body = {
          warehouseNodeId: node.data.id,
          warehouseNodeType: node.data.childSiteType
        }
        warehouseNode(body).then(res => {
          console.log(res)
          let data = res.data[0]
          if (level === 1) {
            let body = {
              warehouseNodeId: data.id,
              warehouseNodeType: data.siteType
            }
            this.loading = true
            this.warehouseNodeId = data.id
            this.warehouseNodeId_ = data.id
            this.warehouseNodeType = data.siteType
            this.warehouseNodeType_ = data.childSiteType
            this.title = data.name
            this.title_ = data.name
            warehouseInfo(body).then(res => {
              console.log(res)
              this.warehouse = {
                name: res.data.name,
                age: daysDistance(res.data.buildTime),
                buildTime: res.data.buildTime,
                code: res.data.code,
                useVolume: res.data.useVolume,
                useVolumeUnit: res.data.useVolumeUnit,
                useArea: res.data.useArea,
                useAreaUnit: res.data.useAreaUnit,
                isAutomation: res.data.isAutomation,
                isStatistics: res.data.isStatistics,
                isUsing: res.data.isUsing,
                remark: res.data.remark,
                id: res.data.id
              }
              this.loading = false
              this.$refs.tree.setCurrentKey(this.treeId)
            }).catch(err => {
              console.log(err)
            })
          }
          if (node.data.childSiteType === '04') {
            res.data.map(item => {
              item.leaf = true
            })
            resolve(res.data)
          } else {
            resolve(res.data)
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    requestTree (resolve) {
      let data = {
        childSiteType: '01',
        id: 1,
        name: '顶级',
        siteType: '00',
        treeId: '000'
      }
      resolve([data])
    },
    checkChange: function (data, node) {
      console.log(data)
      this.warehouseNodeId = data.id
      this.warehouseNodeId_ = data.id
      this.warehouseNodeType = data.siteType
      this.warehouseNodeType_ = data.childSiteType
      if (data.treeId === this.treeId) {
        this.treeId = data.treeId
        this.treeId_ = data.treeId
      } else {
        this.treeId = data.treeId
        this.treeId_ = data.treeId
        this.title = data.name
        this.title_ = data.name
        let body = {
          warehouseNodeId: data.id,
          warehouseNodeType: data.siteType
        }
        this.loading = true
        warehouseInfo(body).then(res => {
          console.log(res)
          if (data.siteType === '01') {
            this.warehouse = {
              name: res.data.name,
              buildTime: res.data.buildTime,
              age: daysDistance(res.data.buildTime),
              code: res.data.code,
              useVolume: res.data.useVolume,
              useVolumeUnit: res.data.useVolumeUnit,
              useArea: res.data.useArea,
              useAreaUnit: res.data.useAreaUnit,
              isAutomation: res.data.isAutomation,
              isStatistics: res.data.isStatistics,
              isUsing: res.data.isUsing,
              remark: res.data.remark,
              id: res.data.id
            }
          } else if (data.siteType === '02') {
            this.building = {
              buildingName: res.data.buildingName,
              buildingNo: res.data.buildingNo,
              useVolume: res.data.useVolume,
              useVolumeUnit: res.data.useVolumeUnit,
              useArea: res.data.useArea,
              useAreaUnit: res.data.useAreaUnit,
              buildingOrientation: res.data.buildingOrientation,
              remark: res.data.remark,
              warehouseId: res.data.warehouseId,
              id: res.data.id
            }
          } else if (data.siteType === '03') {
            this.floor = {
              floorName: res.data.floorName,
              floorNo: res.data.floorNo,
              isPartition: res.data.isPartition,
              remark: res.data.remark,
              buildingId: res.data.buildingId,
              id: res.data.id
            }
          } else if (data.siteType === '04') {
            this.area = {
              areaName: res.data.areaName,
              areaNo: res.data.areaNo,
              remark: res.data.remark,
              floorId: res.data.floorId,
              id: res.data.id
            }
            this.page = 1
            this.handleSearch()
          }
          this.loading = false
        }).catch(err => {
          console.log(err)
        })
      }
    },
    isEmptyObject: function (obj) {
      for (let n in obj) { return false }
      return true
    },
    warehouseIsAutomation: function (data) {
      this.warehouse.isAutomation = data.value
    },
    warehouseIsStatistics: function (data) {
      this.warehouse.isStatistics = data.value
    },
    warehouseIsUsing: function (data) {
      this.warehouse.isUsing = data.value
    },
    areaIsPartition: function (data) {
      this.floor.isPartition = data.value
    },
    warehouseIsAutomation_: function (data) {
      this.warehouse_.isAutomation = data.value
    },
    warehouseIsStatistics_: function (data) {
      this.warehouse_.isStatistics = data.value
    },
    warehouseIsUsing_: function (data) {
      this.warehouse_.isUsing = data.value
    },
    areaIsPartition_: function (data) {
      this.floor_.isPartition = data.value
    },
    showInfo: function (data) {
      console.log(data)
    },
    showDropInfo: function (data) {
      console.log(data)
      this.title_ = data.name
      this.treeId_ = data.treeId
      this.warehouseNodeId_ = data.id
      this.warehouseNodeType_ = data.childSiteType
      if (this.warehouseNodeType_ === '01') {
        this.warehouse_ = {
          name: '',
          age: '',
          buildTime: '',
          code: '',
          useVolume: '',
          useVolumeUnit: '',
          useArea: '',
          useAreaUnit: '',
          isAutomation: true,
          isStatistics: true,
          isUsing: true,
          remark: '',
          id: ''
        }
      } else if (this.warehouseNodeType_ === '02') {
        this.building_ = {
          buildingName: '',
          buildingNo: '',
          useVolume: '',
          useVolumeUnit: '',
          useArea: '',
          useAreaUnit: '',
          buildingOrientation: '',
          remark: '',
          warehouseId: this.warehouseNodeId_,
          id: ''
        }
      } else if (this.warehouseNodeType_ === '03') {
        this.floor_ = {
          floorName: '',
          floorNo: '',
          isPartition: true,
          remark: '',
          buildingId: this.warehouseNodeId_,
          id: ''
        }
      } else if (this.warehouseNodeType_ === '04') {
        this.area_ = {
          areaName: '',
          areaNo: '',
          remark: '',
          floorId: this.warehouseNodeId_,
          id: ''
        }
      }
    },
    showAddModal: function () {
      console.log(this.warehouseNodeType_)
      if (this.warehouseNodeType_ === '01') {
        this.warehouse_ = {
          name: '',
          age: '',
          buildTime: '',
          code: '',
          useVolume: '',
          useVolumeUnit: '',
          useArea: '',
          useAreaUnit: '',
          isAutomation: true,
          isStatistics: true,
          isUsing: true,
          remark: '',
          id: ''
        }
        this.showAdd = true
      } else if (this.warehouseNodeType_ === '02') {
        this.building_ = {
          buildingName: '',
          buildingNo: '',
          useVolume: '',
          useVolumeUnit: '',
          useArea: '',
          useAreaUnit: '',
          buildingOrientation: '',
          remark: '',
          warehouseId: this.warehouseNodeId_,
          id: ''
        }
        this.showAdd = true
      } else if (this.warehouseNodeType_ === '03') {
        this.floor_ = {
          floorName: '',
          floorNo: '',
          isPartition: true,
          remark: '',
          buildingId: this.warehouseNodeId_,
          id: ''
        }
        this.showAdd = true
      } else if (this.warehouseNodeType_ === '04') {
        this.area_ = {
          areaName: '',
          areaNo: '',
          remark: '',
          floorId: this.warehouseNodeId_,
          id: ''
        }
        this.showAdd = true
      } else if (this.warehouseNodeType_ === '05') {
        this.showAddCrib = true
        this.stack = {
          nameCn: '',
          remark: '',
          stackNo: '',
          areaId: this.warehouseNodeId_,
          id: ''
        }
      }
    },
    cancelAdd: function () {
      this.showAdd = false
    },
    confirmAdd: function () {
      console.log(this.treeId_)
      if (this.warehouseNodeType_ === '01') {
        let body = this.warehouse_
        if (
          noEmpty(this.warehouse_.name, '请输入仓库名称', '') &&
          noEmpty(this.warehouse_.buildTime, '请选择建造时间', '') &&
          NonChineseInput(this.warehouse_.code, '请输入仓库代码', '仓库代码不可输入中文', '') &&
          noEmpty(this.warehouse_.useVolume, '请输入可堆货容积', '') &&
          noEmpty(this.warehouse_.useVolumeUnit, '请输入可堆货容积单位', '') &&
          noEmpty(this.warehouse_.useArea, '请输入可堆货面积', '') &&
          noEmpty(this.warehouse_.useAreaUnit, '请输入可堆货面积单位', '')
        ) {
          addWarehouse(body).then(res => {
            console.log(res)
            let data = res.data
            this.$refs.tree.append(data, data.parentTreeId)
            this.$message({
              message: '添加成功',
              type: 'success',
              center: 'true',
              duration: '1000'
            })
            this.showAdd = false
          }).catch(err => {
            console.log(err)
          })
        }
      } else if (this.warehouseNodeType_ === '02') {
        let body = this.building_
        if (
          noEmpty(this.building_.buildingName, '请输入楼号名称', '') &&
          NonChineseInput(this.building_.buildingNo, '请输入楼号代码', '楼号代码不可输入中文', '') &&
          noEmpty(this.building_.useVolume, '请输入可堆货容积', '') &&
          noEmpty(this.building_.useVolumeUnit, '请输入可堆货容积单位', '') &&
          noEmpty(this.building_.useArea, '请输入可堆货面积', '') &&
          noEmpty(this.building_.useAreaUnit, '请输入可堆货面积单位', '')
        ) {
          addBuilding(body).then(res => {
            console.log(res)
            let data = res.data
            this.$refs.tree.append(data, data.parentTreeId)
            this.$message({
              message: '添加成功',
              type: 'success',
              center: 'true',
              duration: '1000'
            })
            this.showAdd = false
          }).catch(err => {
            console.log(err)
          })
        }
      } else if (this.warehouseNodeType_ === '03') {
        let body = this.floor_
        if (
          noEmpty(this.floor_.floorName, '请输入层号名称', '') &&
          NonChineseInput(this.floor_.floorNo, '请输入层号代码', '层号代码不可输入中文', '')
        ) {
          addFloor(body).then(res => {
            console.log(res)
            let data = res.data
            this.$refs.tree.append(data, data.parentTreeId)
            this.$message({
              message: '添加成功',
              type: 'success',
              center: 'true',
              duration: '1000'
            })
            this.showAdd = false
          }).catch(err => {
            console.log(err)
          })
        }
      } else if (this.warehouseNodeType_ === '04') {
        let body = this.area_
        if (
          noEmpty(this.area_.areaName, '请输入区号名称', '') &&
          NonChineseInput(this.area_.areaNo, '请输入区号代码', '区号代码不可输入中文', '')
        ) {
          addWarearea(body).then(res => {
            console.log(res)
            let data = res.data
            data.leaf = true
            this.$refs.tree.append(data, data.parentTreeId)
            this.$message({
              message: '添加成功',
              type: 'success',
              center: 'true',
              duration: '1000'
            })
            this.showAdd = false
          }).catch(err => {
            console.log(err)
          })
        }
      }
    },
    showDeleteModal: function () {
      if (this.treeId === '000') {
        this.$message({
          message: '请选择要删除的数据',
          type: 'success',
          center: 'true',
          duration: '1000'
        })
      } else {
        this.showDelete = true
      }
    },
    cancelDeleteN: function () {
      this.showDelete = false
    },
    confirmDeleteN: function () {
      console.log(this.node)
      let body = {
        warehouseNodeId: this.warehouseNodeId,
        warehouseNodeType: this.warehouseNodeType
      }
      delWarehouse(body).then(res => {
        this.$refs.tree.remove(this.$refs.tree.getNode(this.treeId))
        this.treeId = '000'
        this.$refs.tree.setCurrentKey(this.treeId)
        this.title_ = '顶级'
        this.warehouseNodeType_ = '01'
        this.warehouseNodeId = ''
        this.showDelete = false
        this.$message({
          message: res.data,
          type: 'success',
          center: 'true',
          duration: '1000',
          customClass: 'user-message'
        })
      }).then(err => {
        console.log(err)
      })
    },
    deleteSingle: function (id) {
      this.show = true
      this.id = id
    },
    cancelDelete: function () {
      this.show = false
    },
    confirmDelete: function () {
      let body = {
        warehouseNodeId: this.id,
        warehouseNodeType: '05'
      }
      delWarehouse(body).then(res => {
        console.log(res)
        this.handleSearch()
        this.$message({
          message: '删除成功!',
          type: 'success',
          center: 'true',
          duration: '1000',
          customClass: 'user-message'
        })
        this.show = false
      }).catch(err => {
        console.log(err)
      })
    },
    showAddCribModal: function (type, data) {
      this.cribType = type
      if (type === 1) {
        this.stack = {
          nameCn: '',
          remark: '',
          stackNo: '',
          areaId: this.warehouseNodeId,
          id: ''
        }
      } else if (type === 2) {
        this.stack = {
          nameCn: data.nameCn,
          remark: data.remark,
          stackNo: data.stackNo,
          areaId: data.areaId,
          id: data.id
        }
      }
      this.showAddCrib = true
    },
    cancelAddCrib: function () {
      this.showAddCrib = false
    },
    confirmAddCrib: function () {
      if (
        noEmpty(this.stack.nameCn, '请输入垛位名称', 'user-message') &&
        NonChineseInput(this.stack.stackNo, '请输入垛位编号', '垛位编号不可输入中文', 'user-message')
      ) {
        if (this.cribType === 1) {
          addStack(this.stack).then(res => {
            console.log(res)
            this.$message({
              message: '添加成功!',
              type: 'success',
              center: 'true',
              duration: '1000',
              customClass: 'user-message'
            })
            this.showAddCrib = false
            this.handleSearch()
          }).catch(err => {
            console.log(err)
          })
        } else if (this.cribType === 2) {
          updateStack(this.stack).then(res => {
            console.log(res)
            this.showAddCrib = false
            this.handleSearch()
          }).catch(err => {
            console.log(err)
          })
        }
      }
    },
    handleEdit: function () {
      if (this.warehouseNodeType === '01') {
        let body = this.warehouse
        if (
          noEmpty(this.warehouse.name, '请输入仓库名称', 'user-message') &&
          noEmpty(this.warehouse.buildTime, '请选择建造时间', 'user-message') &&
          NonChineseInput(this.warehouse.code, '请输入仓库代码', '仓库代码不可输入中文', 'user-message') &&
          noEmpty(this.warehouse.useVolume, '请输入可堆货容积', 'user-message') &&
          noEmpty(this.warehouse.useVolumeUnit, '请输入可堆货容积单位', 'user-message') &&
          noEmpty(this.warehouse.useArea, '请输入可堆货面积', 'user-message') &&
          noEmpty(this.warehouse.useAreaUnit, '请输入可堆货面积单位', 'user-message')
        ) {
          updateWarehouse(body).then(res => {
            console.log(res)
            let body = {
              warehouseNodeType: this.warehouseNodeType,
              warehouseNodeId: res.data.pid
            }
            warehouseNode(body).then(res_ => {
              console.log(res_)
              this.$refs.tree.updateKeyChildren(res.data.parentTreeId, res_.data)
              this.$refs.tree.setCurrentKey(this.treeId)
              this.$message({
                message: '保存成功',
                type: 'success',
                center: 'true',
                duration: '1000'
              })
            }).catch(err => {
              console.log(err)
            })
          }).catch(err => {
            console.log(err)
          })
        }
      } else if (this.warehouseNodeType === '02') {
        let body = this.building
        if (
          noEmpty(this.building.buildingName, '请输入楼号名称', 'user-message') &&
          NonChineseInput(this.building.buildingNo, '请输入楼号代码', '楼号代码不可输入中文', 'user-message') &&
          noEmpty(this.building.useVolume, '请输入可堆货容积', 'user-message') &&
          noEmpty(this.building.useVolumeUnit, '请输入可堆货容积单位', 'user-message') &&
          noEmpty(this.building.useArea, '请输入可堆货面积', 'user-message') &&
          noEmpty(this.building.useAreaUnit, '请输入可堆货面积单位', 'user-message')
        ) {
          updateBuilding(body).then(res => {
            console.log(res)
            let body = {
              warehouseNodeType: this.warehouseNodeType,
              warehouseNodeId: res.data.pid
            }
            warehouseNode(body).then(res_ => {
              console.log(res_)
              this.$refs.tree.updateKeyChildren(res.data.parentTreeId, res_.data)
              this.$refs.tree.setCurrentKey(this.treeId)
              this.$message({
                message: '保存成功',
                type: 'success',
                center: 'true',
                duration: '1000'
              })
            }).catch(err => {
              console.log(err)
            })
          }).catch(err => {
            console.log(err)
          })
        }
      } else if (this.warehouseNodeType === '03') {
        let body = this.floor
        if (
          noEmpty(this.floor.floorName, '请输入层号名称', 'user-message') &&
          NonChineseInput(this.floor.floorNo, '请输入层号代码', '层号代码不可输入中文', 'user-message')
        ) {
          updateFloor(body).then(res => {
            console.log(res)
            let body = {
              warehouseNodeType: this.warehouseNodeType,
              warehouseNodeId: res.data.pid
            }
            warehouseNode(body).then(res_ => {
              console.log(res_)
              this.$refs.tree.updateKeyChildren(res.data.parentTreeId, res_.data)
              this.$refs.tree.setCurrentKey(this.treeId)
              this.$message({
                message: '保存成功',
                type: 'success',
                center: 'true',
                duration: '1000'
              })
            }).catch(err => {
              console.log(err)
            })
          }).catch(err => {
            console.log(err)
          })
        }
      } else if (this.warehouseNodeType === '04') {
        let body = this.area
        if (
          noEmpty(this.area.areaName, '请输入区号名称', 'user-message') &&
          NonChineseInput(this.area.areaNo, '请输入区号代码', '区号代码不可输入中文', 'user-message')
        ) {
          updateWarearea(body).then(res => {
            console.log(res)
            let body = {
              warehouseNodeType: this.warehouseNodeType,
              warehouseNodeId: res.data.pid
            }
            warehouseNode(body).then(res_ => {
              console.log(res_)
              res_.data.map(item => {
                item.leaf = true
              })
              this.$refs.tree.updateKeyChildren(res.data.parentTreeId, res_.data)
              this.$refs.tree.setCurrentKey(this.treeId)
              this.$message({
                message: '保存成功',
                type: 'success',
                center: 'true',
                duration: '1000'
              })
            }).catch(err => {
              console.log(err)
            })
          }).catch(err => {
            console.log(err)
          })
        }
      }
    },
    handleSearch: function () {
      this.loading_ = true
      let body = {
        wareareaId: this.warehouseNodeId,
        page: this.page,
        rows: this.rows
      }
      console.log(body)
      stackPageList(body).then(res => {
        console.log(res)
        this.tableData = res.data.rows
        this.total = res.data.total
        this.loading_ = false
      }).catch(err => {
        console.log(err)
      })
    },
    firstPage: function () {
      console.log('首页')
      if (this.page === 1) {
        this.$message({
          message: '当前为第一页',
          type: 'warning',
          center: 'true',
          duration: '1000',
          customClass: 'user-message'
        })
      } else {
        this.page = 1
        this.handleSearch()
      }
    },
    previousPage: function () {
      console.log('上一页')
      if (this.page < 2) {
        this.$message({
          message: '当前为第一页',
          type: 'warning',
          center: 'true',
          duration: '1000',
          customClass: 'user-message'
        })
      } else {
        this.page--
        this.handleSearch()
      }
    },
    nextPage: function () {
      console.log('下一页')
      if (parseInt(this.total / this.rows) + 1 > this.page) {
        this.page++
        this.handleSearch()
      } else {
        this.$message({
          message: '当前为最后一页',
          type: 'warning',
          center: 'true',
          duration: '1000',
          customClass: 'user-message'
        })
      }
    },
    lastPage: function () {
      console.log('尾页')
      if (this.page === parseInt(this.total / this.rows) + 1) {
        this.$message({
          message: '当前为最后一页',
          type: 'warning',
          center: 'true',
          duration: '1000',
          customClass: 'user-message'
        })
      } else {
        if (Math.round(this.total % this.rows) === 0) {
          this.page = parseInt(this.total / this.rows)
        } else {
          this.page = parseInt(this.total / this.rows) + 1
        }
        this.handleSearch()
      }
    }
  }
}
</script>

<style scoped>
@import "./Storehouse.css";
</style>



// WEBPACK FOOTER //
// src/page/basic/storehourse/Storehouse.vue